import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Minus, Plus, X } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const Cart24 = () => {
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([
        {
            id: 1,
            name: 'Silk Chanderi Drape',
            price: 14500,
            size: 'M',
            quantity: 1,
            image: 'https://images.pexels.com/photos/8980747/pexels-photo-8980747.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
        {
            id: 2,
            name: 'The Monsoon Kurta',
            price: 7800,
            size: 'S',
            quantity: 2,
            image: 'https://images.pexels.com/photos/6712369/pexels-photo-6712369.jpeg?auto=compress&cs=tinysrgb&w=600',
        },
    ]);

    const updateQuantity = (id, delta) => {
        setCartItems(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, quantity: Math.max(1, item.quantity + delta) }
                    : item
            )
        );
    };

    const removeItem = (id) => {
        setCartItems(prev => prev.filter(item => item.id !== id));
    };

    const subtotal = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shipping = subtotal > 10000 ? 0 : 500;
    const total = subtotal + shipping;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-cart {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-cart-inner {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 60px 40px 120px;
                }
                .dhara-cart-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 42px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 12px;
                    letter-spacing: -0.5px;
                }
                .dhara-cart-count {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    font-weight: 300;
                    margin-bottom: 60px;
                }
                .dhara-cart-layout {
                    display: grid;
                    grid-template-columns: 1.5fr 1fr;
                    gap: 80px;
                    align-items: start;
                }
                .dhara-cart-items {
                    display: flex;
                    flex-direction: column;
                }
                .dhara-cart-item {
                    display: grid;
                    grid-template-columns: 120px 1fr auto;
                    gap: 32px;
                    padding: 32px 0;
                    border-bottom: 1px solid #E5E5E5;
                    align-items: start;
                }
                .dhara-cart-item:first-child {
                    padding-top: 0;
                }
                .dhara-cart-item-img {
                    width: 120px;
                    height: 160px;
                    object-fit: cover;
                    background: #FAFAF8;
                    cursor: pointer;
                }
                .dhara-cart-item-name {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 6px;
                }
                .dhara-cart-item-size {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #6B6B6B;
                    margin-bottom: 20px;
                }
                .dhara-cart-item-qty {
                    display: flex;
                    align-items: center;
                    gap: 0;
                }
                .dhara-cart-qty-btn {
                    width: 36px;
                    height: 36px;
                    border: 1px solid #E5E5E5;
                    background: transparent;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #1A1A1A;
                    transition: border-color 0.3s ease;
                }
                .dhara-cart-qty-btn:hover {
                    border-color: #1A1A1A;
                }
                .dhara-cart-qty-val {
                    width: 44px;
                    height: 36px;
                    border-top: 1px solid #E5E5E5;
                    border-bottom: 1px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #1A1A1A;
                }
                .dhara-cart-item-right {
                    text-align: right;
                }
                .dhara-cart-item-price {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 12px;
                }
                .dhara-cart-remove {
                    background: none;
                    border: none;
                    cursor: pointer;
                    color: #6B6B6B;
                    transition: color 0.3s ease;
                    padding: 0;
                }
                .dhara-cart-remove:hover {
                    color: #1A1A1A;
                }

                /* Summary */
                .dhara-cart-summary {
                    background: #FAFAF8;
                    padding: 40px;
                    position: sticky;
                    top: 100px;
                }
                .dhara-cart-summary-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 2px;
                    text-transform: uppercase;
                    color: #1A1A1A;
                    margin-bottom: 32px;
                }
                .dhara-cart-summary-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 16px;
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                }
                .dhara-cart-summary-total {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 24px;
                    padding-top: 24px;
                    border-top: 1px solid #E5E5E5;
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    color: #1A1A1A;
                }
                .dhara-cart-checkout-btn {
                    width: 100%;
                    height: 52px;
                    background: #00553A;
                    color: #FFFFFF;
                    border: none;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    cursor: pointer;
                    margin-top: 32px;
                    transition: background 0.3s ease;
                }
                .dhara-cart-checkout-btn:hover {
                    background: #006B4A;
                }
                .dhara-cart-continue {
                    display: block;
                    text-align: center;
                    margin-top: 20px;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #6B6B6B;
                    cursor: pointer;
                    background: none;
                    border: none;
                    width: 100%;
                    transition: color 0.3s ease;
                }
                .dhara-cart-continue:hover {
                    color: #00553A;
                }
                .dhara-cart-shipping-note {
                    font-family: 'Inter', sans-serif;
                    font-size: 12px;
                    color: #00553A;
                    margin-top: 12px;
                    text-align: center;
                }

                /* Empty */
                .dhara-cart-empty {
                    text-align: center;
                    padding: 100px 20px;
                }
                .dhara-cart-empty-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 28px;
                    color: #1A1A1A;
                    margin-bottom: 16px;
                }
                .dhara-cart-empty-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    margin-bottom: 40px;
                }
                .dhara-cart-empty-btn {
                    display: inline-block;
                    padding: 14px 40px;
                    background: #00553A;
                    color: #FFFFFF;
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                    letter-spacing: 1.5px;
                    text-transform: uppercase;
                    border: none;
                    cursor: pointer;
                    transition: background 0.3s ease;
                }
                .dhara-cart-empty-btn:hover {
                    background: #006B4A;
                }

                @media (max-width: 768px) {
                    .dhara-cart-inner { padding: 40px 20px 80px; }
                    .dhara-cart-title { font-size: 32px; }
                    .dhara-cart-layout {
                        grid-template-columns: 1fr;
                        gap: 40px;
                    }
                    .dhara-cart-item {
                        grid-template-columns: 90px 1fr;
                        gap: 16px;
                    }
                    .dhara-cart-item-right {
                        grid-column: 1 / -1;
                        text-align: left;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }
                    .dhara-cart-summary { padding: 24px; }
                }
            `}</style>

            <Header24 cartCount={cartItems.length} />

            <main className="dhara-cart">
                <div className="dhara-cart-inner">
                    <h1 className="dhara-cart-title">Your Bag</h1>
                    <p className="dhara-cart-count">
                        {cartItems.length} {cartItems.length === 1 ? 'piece' : 'pieces'}
                    </p>

                    {cartItems.length === 0 ? (
                        <div className="dhara-cart-empty">
                            <h2 className="dhara-cart-empty-title">Your bag is empty</h2>
                            <p className="dhara-cart-empty-text">
                                Discover our curated collection of handcrafted pieces.
                            </p>
                            <button
                                className="dhara-cart-empty-btn"
                                onClick={() => navigate('/template24/shop')}
                            >
                                Continue Shopping
                            </button>
                        </div>
                    ) : (
                        <div className="dhara-cart-layout">
                            {/* Items */}
                            <div className="dhara-cart-items">
                                {cartItems.map(item => (
                                    <div key={item.id} className="dhara-cart-item">
                                        <img
                                            className="dhara-cart-item-img"
                                            src={item.image}
                                            alt={item.name}
                                            onClick={() => navigate(`/template24/product/${item.id}`)}
                                        />
                                        <div>
                                            <div className="dhara-cart-item-name">{item.name}</div>
                                            <div className="dhara-cart-item-size">Size: {item.size}</div>
                                            <div className="dhara-cart-item-qty">
                                                <button
                                                    className="dhara-cart-qty-btn"
                                                    onClick={() => updateQuantity(item.id, -1)}
                                                >
                                                    <Minus size={14} strokeWidth={1.5} />
                                                </button>
                                                <div className="dhara-cart-qty-val">{item.quantity}</div>
                                                <button
                                                    className="dhara-cart-qty-btn"
                                                    onClick={() => updateQuantity(item.id, 1)}
                                                >
                                                    <Plus size={14} strokeWidth={1.5} />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="dhara-cart-item-right">
                                            <div className="dhara-cart-item-price">
                                                {'\u20B9'}{(item.price * item.quantity).toLocaleString('en-IN')}
                                            </div>
                                            <button
                                                className="dhara-cart-remove"
                                                onClick={() => removeItem(item.id)}
                                            >
                                                <X size={18} strokeWidth={1.5} />
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Summary */}
                            <div className="dhara-cart-summary">
                                <div className="dhara-cart-summary-title">Order Summary</div>
                                <div className="dhara-cart-summary-row">
                                    <span>Subtotal</span>
                                    <span>{'\u20B9'}{subtotal.toLocaleString('en-IN')}</span>
                                </div>
                                <div className="dhara-cart-summary-row">
                                    <span>Shipping</span>
                                    <span>{shipping === 0 ? 'Complimentary' : `\u20B9${shipping}`}</span>
                                </div>
                                <div className="dhara-cart-summary-total">
                                    <span>Total</span>
                                    <span>{'\u20B9'}{total.toLocaleString('en-IN')}</span>
                                </div>
                                <button
                                    className="dhara-cart-checkout-btn"
                                    onClick={() => navigate('/template24/checkout')}
                                >
                                    Proceed to Checkout
                                </button>
                                <button
                                    className="dhara-cart-continue"
                                    onClick={() => navigate('/template24/shop')}
                                >
                                    Continue Shopping
                                </button>
                                {subtotal < 10000 && (
                                    <div className="dhara-cart-shipping-note">
                                        Free shipping on orders above {'\u20B9'}10,000
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default Cart24;
